module.exports = __webpack_public_path__ + "img/course_class.fdd66cdf.svg";